import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerWrapper: {
        flexDirection: "row",
        alignItems: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitleContainer: {
        position: "absolute",
        left: 0,
        right: 0
    },
    headerTitle: {
        alignSelf: "center"
    },
    editImageButton: {
        position: "absolute",
        zIndex: 500
    },
    campaignTag: {
        position: "absolute",
        zIndex: 500
    },
    coverphoto: {
        position: "absolute",
        height: "100%",
        width: "100%",
        zIndex: 99,
        bottom: 0,
        right: 0,
        left: 0,
        top: 0
    },
    campaignLogo: {
        width: "100%",
        aspectRatio: 0,
        height: 200
    },
    actionButtonsContainer: {
        flex: 1
    },
    dialogHeader: {
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center"
    },
    successIconContainer: {
        alignSelf: "center"
    },
    dialogIconContainer: {
        alignSelf: "center"
    },
    textCenter: {
        textAlign: "center"
    }
});
export default stylesheet;
